import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

export const useStickToViewportTop = (elementRef, onScrollChange) => {
  const [initialOffset, setInitialOffset] = useState(0);

  useEffect(() => {
    const stickElementToTop = () => {
      if (!elementRef?.current) {
        return;
      }

      const offsetTop = elementRef?.current?.offsetTop;

      if (!initialOffset && offsetTop) {
        setInitialOffset(offsetTop);
      }

      const currentScroll = window.pageYOffset;
      if (currentScroll >= initialOffset) {
        onScrollChange(true)
      } else {
        onScrollChange(false);
      }
    };

    window.addEventListener('scroll', stickElementToTop)

    return () => {
      window.removeEventListener('scroll', stickElementToTop);
    }
  }, [elementRef, initialOffset, onScrollChange]);
};

export const StickyBar = ({ children, id = 'sticky-bar' }) => {
  const [areControlsOutOfViewport, setControlsOutOfViewport] = useState(false);
  const stickyRow = useRef(null);

  useStickToViewportTop(stickyRow, setControlsOutOfViewport);

  return (
    <div
      id={`${id}-dock`}
      className="w-full max-w-screen-xl h-24 mb-8"
    >
      <div
        id={id}
        ref={stickyRow}
        className={classNames('bg-white/100 z-30 w-full max-w-screen-xl flex flex-col p-4 shadow border border-border-light rounded-b-sm', {
          'top-0': areControlsOutOfViewport,
          fixed: areControlsOutOfViewport,
          relative: !areControlsOutOfViewport,
        })}
      >
        {children}
      </div>
    </div>
  )
}

export default StickyBar;
